/* @flow */

import { getSentryDsn } from 'src/shared/core/util/vendor/sentryUtil';
import {
  errorReportingProjectId,
  errorReportingPublicKey,
  errorReportingWhiteUrls,
} from 'src/shared/app/base/settings/appSettings';

/**
 * Get the Sentry options for configuration
 * @param  {string} version - Version of the app
 * @param  {string} environment - Environment
 * @param  {string} platformUrl - Url of the platform
 * @return {Object} Options
 */
export function getSentryOptions(
  version: string,
  environment: string,
  platformUrl: ?string,
): Object {
  return {
    dsn: getSentryDsn(errorReportingProjectId, errorReportingPublicKey),
    release: version,
    environment,
    _whitelistUrls: [...errorReportingWhiteUrls, platformUrl].filter(Boolean),
  };
}
